import MIXPANEL from "@constants/mixpanel";
import mixpanel from "mixpanel-browser";
import {
  LOCALSTORAGE,
  PACK_TYPE,
  SEARCH_PARAM,
  SECTION_SOURCE,
  WEB_SMALL_PAYMENT_SOURCE,
} from "@constants";
import { deleteKey, getKey, setKey } from "@utils/storage";
import {
  getDeviceId,
  getMixpanelId,
  getMixpanelPeopleProperties,
  getSearchParam,
  isHelpCenterWebView,
  isUserloggedIn,
  mixpanelGetSuperProperties,
  setMixpanelId,
} from "@utils/common";
import { ACCOUNT_STATUS } from "@containers/BingeLogin/APIs/constants";
import isEmpty from "lodash/isEmpty";
import store from "@src/store";
import get from "lodash/get";
import { getDateFromString } from "./common";

const noop = () => {};
// const mixPanelTemp = mixpanel?.people ? mixpanel : {
//     get_distinct_id: noop,
//     track: noop,
//     unregister: noop,
//     register: noop,
//     identify: noop,
//     get_group: noop,
//     set_group: noop,
//     people: {
//         unset: noop,
//         set: noop
//     }
// };
const mixPanelTemp = mixpanel;

let mixPanelConfig = {
  initialData: {},

  identifyUser(identifyUser = false) {
    const isManualLogin = store.getState().loginReducer?.isManualLogin;

    let userInfo = JSON.parse(getKey(LOCALSTORAGE.USER_INFO)) || {};
    let mixpanelId = "";
    const mixpanelIdSearchParam = getSearchParam(SEARCH_PARAM.MIXPANEL_ID);
    if (mixpanelIdSearchParam) {
      mixpanelId = mixpanelIdSearchParam;
    } else if (!isEmpty(userInfo)) {
      mixpanelId = userInfo?.mixpanelId;
    } else {
      mixpanelId = getMixpanelId();
      if (!mixpanelId) {
        mixpanelId = mixPanelTemp.get_distinct_id();
      }
    }
    setMixpanelId(mixpanelId);
    // call identify only if not accessed from helpCenterWebview and userLoggedIn manually or identifyUser flag is true.
    //  if(!isHelpCenterWebView() &&  (isManualLogin || identifyUser)){
    if (isManualLogin || identifyUser) {
      mixPanelTemp.identify(mixpanelId);
    } else {
      mixPanelTemp.register({ distinct_id: mixpanelId });
    }
    return mixpanelId;
  },

  reset() {
    mixPanelTemp?.reset();
    const distinctId = mixPanelTemp.get_distinct_id();
    setKey(LOCALSTORAGE.MIXPANEL_DISTINCT_ID, distinctId);
    return distinctId;
  },

  resetUserType() {
    const superProperties = mixpanelGetSuperProperties();
    superProperties[MIXPANEL.PARAMETER.USER_TYPE] = MIXPANEL.VALUE.GUEST;
    setKey(LOCALSTORAGE.MIXPANEL_SUPER_PROPERTIES, superProperties);
    mixPanelTemp?.register(superProperties);
  },

  setPeopleProperties() {
    let properties = getMixpanelPeopleProperties();
    mixPanelTemp.people && mixPanelTemp.people.set(properties);
  },

  setSuperProperties() {
    const superProperties = mixpanelGetSuperProperties();
    setKey(LOCALSTORAGE.MIXPANEL_SUPER_PROPERTIES, superProperties);
    mixPanelTemp?.register(superProperties);
  },

  unsetSuperProperties() {
    mixPanelTemp.people.unset(MIXPANEL.PARAMETER.TS_SID);
    mixPanelTemp.people.unset(MIXPANEL.PARAMETER.C_ID);
    mixPanelTemp.unregister(MIXPANEL.PARAMETER.TS_SID);
    mixPanelTemp.unregister(MIXPANEL.PARAMETER.C_ID);
    deleteKey(LOCALSTORAGE.MIXPANEL_SUPER_PROPERTIES);
  },

  setGroup() {
    let userInfo = JSON.parse(getKey(LOCALSTORAGE.USER_INFO)) || {};
    !isEmpty(userInfo) && mixPanelTemp?.set_group("SID", userInfo?.sId);
  },

  setGroupProperties() {
    let userInfo = JSON.parse(getKey(LOCALSTORAGE.USER_INFO)) || {};
    if (!isEmpty(userInfo)) {
      let properties = getMixpanelPeopleProperties();
      mixPanelTemp
        ?.get_group("SID", userInfo?.sId)
        ?.unset(MIXPANEL.PARAMETER.TS_SID);
      mixPanelTemp
        ?.get_group("SID", userInfo?.sId)
        ?.unset(MIXPANEL.PARAMETER.C_ID);
      mixPanelTemp?.get_group("SID", userInfo?.sId)?.set(properties);
    }
  },

  profileChanges() {
    let userInfo = JSON.parse(getKey(LOCALSTORAGE.USER_INFO)) || {};
    if (mixPanelTemp) {
      mixPanelTemp?.people &&
        mixPanelTemp.people.set({
          "FIRST-NAME": `${userInfo?.firstName}`,
          "LAST-NAME": userInfo?.lastName,
          EMAIL: userInfo?.email,
          RMN: userInfo?.rmn,
          SID: userInfo?.sId,
          "DEVICE-ID": getDeviceId(),
        });
    }
  },

  subscriptionDetailChanges() {
    let userInfo = JSON.parse(getKey(LOCALSTORAGE.USER_INFO)) || {};
    let planType = userInfo?.planType;
    let subscriptionType = userInfo?.subscriptionType;
    const state = store.getState();
    let currentSubscription = get(
      state.packSelectionDetail,
      "currentSubscription.data"
    );
    if (mixPanelTemp) {
      mixPanelTemp?.people &&
        mixPanelTemp.people?.set({
          SUBSCRIBED:
            userInfo.bingeAccountStatus === ACCOUNT_STATUS.ACTIVE
              ? MIXPANEL.VALUE.YES
              : MIXPANEL.VALUE.NO,
          "FREE-TRIAL": !isEmpty(planType)
            ? planType?.toLowerCase() === PACK_TYPE.FREE
              ? MIXPANEL.VALUE.YES
              : MIXPANEL.VALUE.NO
            : "",
          "DATE-OF-SUBSCRIPTION": userInfo?.packCreationDate,
          "PACK-NAME": !isEmpty(planType) ? userInfo.packName : "",
          "PACK-PRICE": !isEmpty(planType) ? userInfo.packPrice : "",
          "SUBSCRIPTION-TYPE": !isEmpty(planType)
            ? subscriptionType
            : MIXPANEL.VALUE.UNSUBSCRIBED,
          "PACK-RENEWAL-DATE": getDateFromString(userInfo?.rechargeDue),
          "PACK-START-DATE": new Date(userInfo?.packCreationDate),
          "PACK-END-DATE": getDateFromString(userInfo?.expirationDate),
        });

      /*
       * current subscription api -  null - property update not required
       * current subscription api - user has some pack or written off - FREE-TRIAL-ELIGIBLE - NO
       * */
      if (!isEmpty(currentSubscription)) {
        mixPanelTemp?.people &&
          mixPanelTemp.people?.set({
            "FREE-TRIAL-ELIGIBLE": MIXPANEL.VALUE.NO,
          });
      }
    }
  },
  trackEvent(event, data) {
    if (isUserloggedIn()) {
      let updatedData = {},
        keys,
        sourceIsMSales =
          getKey(LOCALSTORAGE.PAYMENT_SOURCE_KEY) ===
          WEB_SMALL_PAYMENT_SOURCE.NON_BINGE;
      updatedData = data;
      updatedData && (keys = Object.keys(updatedData));
      if (updatedData && keys.length > 0) {
        keys.forEach((keyName) => {
          if (
            updatedData[keyName] === null ||
            updatedData[keyName] === "null" ||
            updatedData === undefined
          ) {
            updatedData[keyName] = "";
          } else {
            updatedData[keyName] =
              updatedData[keyName] || (updatedData[keyName] === 0 ? 0 : "");
          }
        });

        keys.indexOf(MIXPANEL.PARAMETER.SOURCE) >= 0 &&
          (updatedData[MIXPANEL.PARAMETER.SOURCE] = sourceIsMSales
            ? MIXPANEL.VALUE.M_SALES
            : updatedData[MIXPANEL.PARAMETER.SOURCE] || "OTHERS");
        keys.indexOf(MIXPANEL.PARAMETER.TITLE_SECTION) >= 0 &&
          (updatedData[MIXPANEL.PARAMETER.TITLE_SECTION] =
            updatedData[MIXPANEL.PARAMETER.TITLE_SECTION] || "OTHERS");
        keys.indexOf(MIXPANEL.PARAMETER.PACK_NAME) >= 0 &&
          (updatedData[MIXPANEL.PARAMETER.PACK_NAME] =
            updatedData[MIXPANEL.PARAMETER.PACK_NAME] ||
            MIXPANEL.VALUE.FREEMIUM);
        keys.indexOf(MIXPANEL.PARAMETER.PACK_TYPE) >= 0 &&
          (updatedData[MIXPANEL.PARAMETER.PACK_TYPE] =
            updatedData[MIXPANEL.PARAMETER.PACK_TYPE] ||
            MIXPANEL.VALUE.FREEMIUM);
        keys.indexOf(MIXPANEL.PARAMETER.PACK_PRICE) >= 0 &&
          (updatedData[MIXPANEL.PARAMETER.PACK_PRICE] =
            updatedData[MIXPANEL.PARAMETER.PACK_PRICE] ||
            MIXPANEL.VALUE.FREEMIUM);
        keys.indexOf(MIXPANEL.PARAMETER.PAGE_NAME) >= 0 &&
          (updatedData[MIXPANEL.PARAMETER.PAGE_NAME] =
            updatedData[MIXPANEL.PARAMETER.PAGE_NAME] || MIXPANEL.VALUE.OTHERS);
        keys.indexOf(MIXPANEL.PARAMETER.CONTENT_TYPE) >= 0 &&
          (updatedData[MIXPANEL.PARAMETER.CONTENT_TYPE] =
            updatedData[MIXPANEL.PARAMETER.CONTENT_TYPE]?.toUpperCase() ===
            SECTION_SOURCE.RECOMMENDATION
              ? MIXPANEL.VALUE.RECOMMENDATION
              : MIXPANEL.VALUE.EDITORIAL);
        keys.indexOf(MIXPANEL.PARAMETER.RAIL_TYPE) >= 0 &&
          (updatedData[MIXPANEL.PARAMETER.RAIL_TYPE] =
            updatedData[MIXPANEL.PARAMETER.RAIL_TYPE]?.toUpperCase() ||
            MIXPANEL.VALUE.EDITORIAL);
      }
      updatedData
        ? mixPanelTemp.track(event, updatedData)
        : mixPanelTemp.track(event);
    }
  },
  trackErrorCode(error) {
    const httpStatus = error?.data?.[0]?.httpStatus;

    switch (error.code || error) {
      case 3016:
        // Video Processing Errors
        if (error?.message.includes("rendering or decoding issue")) {
          this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.VIDEO_PROCESSING_FAILURE, {
            [MIXPANEL.PARAMETER.REASON]:
              error?.message ||
              "Failed to process a video frame due to a rendering or decoding issue",
          });
        } else if (
          error?.message.includes("VideoFrameProcessor initialization failure")
        ) {
          this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.VIDEO_PROCESSING_FAILURE, {
            [MIXPANEL.PARAMETER.REASON]:
              error?.message ||
              "Failed to initialize the VideoFrameProcessor due to a configuration or resource issue",
          });
        } else {
          this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.VIDEO_PROCESSING_FAILURE, {
            [MIXPANEL.PARAMETER.REASON]:
              error?.message || "General video processing failure",
          });
        }
        break;

      case 1003:
        // Request Timeout
        this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.REQUEST_TIMEOUT, {
          [MIXPANEL.PARAMETER.REASON]: error?.message || "Request timeout",
        });
        break;

      case 1002:
        // Unauthorized or HTTP errors
        if (httpStatus === 0) {
          this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.NO_INTERNET, {
            [MIXPANEL.PARAMETER.REASON]:
              error?.message || "No internet connection",
          });
        } else if (httpStatus === 401) {
          this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.UNAUTHORIZED_ACCESS, {
            [MIXPANEL.PARAMETER.REASON]:
              error?.message || "Unauthorized access",
          });
        } else if (httpStatus === 403) {
          if (error?.message.includes("Content not available in this region")) {
            this.trackEvent(
              MIXPANEL.PLAYER_ERROR_EVENTS.CONTENT_NOT_AVAILABLE_IN_REGION,
              {
                [MIXPANEL.PARAMETER.REASON]:
                  error?.message || "Content not available in this region",
              }
            );
          } else {
            this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.ACCESS_FORBIDDEN, {
              [MIXPANEL.PARAMETER.REASON]: error?.message || "Access forbidden",
            });
          }
        } else if (httpStatus === 404) {
          this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.CONTENT_NOT_FOUND, {
            [MIXPANEL.PARAMETER.REASON]: error?.message || "Content not found",
          });
        } else if (httpStatus === 429) {
          this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.TOO_MANY_REQUESTS, {
            [MIXPANEL.PARAMETER.REASON]:
              error?.message || "Rate limited by server",
          });
        }else{
          this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.TOO_MANY_REQUESTS, {
            [MIXPANEL.PARAMETER.REASON]:
              error?.message
          });
        }
        break;

      case 6012:
      case 6001:
      case 6002:
      case 6003:
      case 6004:
        // DRM Errors
          this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.DRM_FAILURE, {
            [MIXPANEL.PARAMETER.REASON]:
              error?.message
          });
        break;

      case 6008:
        // Media Parsing Failure
        this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.MEDIA_PARSING_FAILURE, {
          [MIXPANEL.PARAMETER.REASON]:
            error?.message ||
            "Failed to parse media container due to a malformed bitstream",
        });
        break;

      case 4010:
        // Input/Output Failure
        this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.INPUT_OUTPUT_FAILURE, {
          [MIXPANEL.PARAMETER.REASON]: error?.message || "I/O operation failed",
        });
        break;

      case 4012:
        // Audio Track Failure
        this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.AUDIO_TRACK_FAILURE, {
          [MIXPANEL.PARAMETER.REASON]: error?.message || "Audio track failure",
        });
        break;

      default:
        // General Player Errors
        
          this.trackEvent(MIXPANEL.PLAYER_ERROR_EVENTS.GENERIC_PLAYBACK_ERROR, {
            [MIXPANEL.PARAMETER.REASON]:
              error?.message || "General player error or unknown issue",
          });
       
        break;
    }
  },
};

export default mixPanelConfig;
